// Libellés propres au tableau de suivi (ceux des retours viennent de
// @feedbaacks/ui). Même traducteur, mêmes trois langues.
import { translator, type Locale } from '@feedbaacks/ui'

const fr = {
  app_title: 'Feedbaacks',
  login_title: 'Connexion au suivi des retours',
  login_email: 'Adresse e-mail',
  login_send: 'Recevoir un code',
  login_sent: 'Si cette adresse a un accès, un code vient de lui être envoyé.',
  login_code: 'Code à 6 chiffres',
  login_verify: 'Se connecter',
  login_other_email: 'Utiliser une autre adresse',
  logout: 'Se déconnecter',
  nav_feedback: 'Retours',
  nav_settings: 'Réglages',
  nav_keys: 'Clés et intégration',
  nav_members: 'Équipe',
  nav_preferences: 'Préférences',
  app_switch: 'Application',
  no_apps: "Aucune application ne vous est ouverte. Demandez à un administrateur de vous ajouter à son équipe.",
  saved: 'Enregistré.',
  save: 'Enregistrer',
  settings_name: 'Nom',
  settings_origins: 'Origines autorisées (une par ligne)',
  settings_origins_hint: 'Les sites qui peuvent poser le widget : https://app.exemple.fr',
  settings_visibility: 'Visibilité',
  settings_visibility_own: 'Chacun voit ses retours (l’équipe admin voit tout)',
  settings_visibility_all: 'Tableau public : tout le monde voit et vote',
  settings_anonymous: 'Accepter les visiteurs anonymes',
  settings_types: 'Types proposés',
  settings_delete_window: 'Délai de suppression par l’auteur (secondes)',
  settings_item_url: 'Lien vers un retour dans votre application ({id} remplacé)',
  settings_notifications: 'E-mails groupés à l’équipe et aux participants',
  settings_monitor: 'Adresses de suivi qui reçoivent tout (une par ligne)',
  settings_agent: 'Agent de traitement',
  settings_trusted: 'Auteurs de confiance (identifiants, un par ligne)',
  settings_approvers: 'Approbateurs (identifiants, un par ligne)',
  settings_stale: 'Reprise d’un retour interrompu après (heures)',
  settings_webhooks: 'Webhooks',
  settings_webhook_url: 'URL (https)',
  settings_webhook_secret: 'Secret (16 caractères au moins)',
  settings_webhook_events: 'Événements (vide = tous)',
  settings_webhook_add: 'Ajouter un webhook',
  settings_webhook_remove: 'Retirer',
  keys_publishable: 'Clé publique (widget)',
  keys_identity_secret: 'Secret d’identité (serveur de l’app uniquement)',
  keys_show: 'Afficher',
  keys_hide: 'Masquer',
  keys_copy: 'Copier',
  keys_copied: 'Copié.',
  keys_rotate: 'Renouveler la clé publique et le secret d’identité',
  keys_rotate_title: 'Renouveler les clés du widget',
  keys_rotate_message: 'Le widget et la signature des identités devront être mis à jour sur votre site. Continuer ?',
  keys_secret_title: 'Clés secrètes (serveur à serveur)',
  keys_secret_label: 'Libellé',
  keys_secret_create: 'Créer une clé secrète',
  keys_secret_once: 'Copiez cette clé maintenant : elle ne sera plus jamais affichée.',
  keys_secret_last_used: 'dernier usage {date}',
  keys_secret_never_used: 'jamais utilisée',
  keys_secret_revoked: 'révoquée',
  keys_revoke: 'Révoquer',
  keys_revoke_title: 'Révoquer la clé',
  keys_revoke_message: 'Les appels signés par cette clé seront refusés immédiatement.',
  keys_snippet: 'Intégration',
  keys_snippet_widget: 'Widget à poser sur votre site',
  keys_snippet_sign: 'Signature de l’identité, côté serveur (Node)',
  members_add: 'Ajouter',
  members_email: 'E-mail',
  members_role: 'Rôle',
  role_admin: 'Admin',
  role_staff: 'Équipe',
  members_remove: 'Retirer',
  members_remove_title: 'Retirer de l’équipe',
  members_remove_message: 'Retirer {name} de l’équipe de cette application ?',
  preferences_digest: 'Recevoir les e-mails groupés des retours',
  nav_admin: 'Administration',
  outbox_title: 'E-mails sortants',
  outbox_intro: 'Aucun e-mail ne part sans validation, sauf les codes de connexion, les alertes de validation et les adresses de suivi d’une application.',
  outbox_disabled: 'La validation est désactivée sur ce serveur : les e-mails partent directement.',
  outbox_tabs: 'Statut des e-mails',
  outbox_tab_pending: 'À valider',
  outbox_tab_sent: 'Envoyés',
  outbox_tab_rejected: 'Refusés',
  outbox_tab_failed: 'En échec',
  outbox_empty_pending: 'Aucun e-mail à valider.',
  outbox_empty_sent: 'Aucun e-mail envoyé.',
  outbox_empty_rejected: 'Aucun e-mail refusé.',
  outbox_empty_failed: 'Aucun e-mail en échec.',
  outbox_reload: 'Réessayer',
  outbox_source_digest: 'Digest de retours',
  outbox_source_notification: 'Notification de la tour',
  outbox_to: 'Pour {recipient}',
  outbox_preview: 'Aperçu',
  outbox_approve: 'Valider',
  outbox_retry: 'Renvoyer',
  outbox_reject: 'Refuser',
  outbox_select: 'Sélectionner l’e-mail pour {recipient}',
  outbox_select_all: 'Tout sélectionner',
  outbox_approve_selection: 'Valider la sélection ({n})',
  outbox_reject_selection: 'Refuser la sélection ({n})',
  outbox_approve_selection_message: 'Envoyer immédiatement les e-mails sélectionnés ({n}) ?',
  outbox_sent: 'E-mail envoyé.',
  outbox_send_failed: 'L’envoi a échoué : {error}',
  outbox_rejected: 'E-mail refusé.',
  outbox_conflict: 'Cet e-mail a déjà été traité.',
  outbox_bulk_approved: 'Envoyés : {approved} · en échec : {failed}.',
  outbox_bulk_rejected: 'Refusés : {rejected} · en échec : {failed}.',
  outbox_reject_title: 'Refuser l’e-mail',
  outbox_reject_message: 'Un e-mail refusé ne part jamais.',
  outbox_reject_reason: 'Motif (facultatif)',
  outbox_sent_at: 'Envoyé le {date}',
  outbox_validated_by: 'Validé par {name}',
  outbox_rejected_by: 'Refusé par {name}',
  outbox_rejected_auto: 'Refus automatique',
  outbox_reason: 'Motif : {reason}',
  outbox_error: 'Erreur : {error}',
  outbox_attempts: 'Essais : {n}',
  error_generic: 'Une erreur est survenue : réessayez.',
  not_found: 'Page introuvable.',
}

export type DashKey = keyof typeof fr

const en: Record<DashKey, string> = {
  app_title: 'Feedbaacks', login_title: 'Sign in to feedback tracking', login_email: 'Email address', login_send: 'Get a code',
  login_sent: 'If this address has access, a code has just been sent.', login_code: '6-digit code', login_verify: 'Sign in',
  login_other_email: 'Use another address', logout: 'Sign out', nav_feedback: 'Feedback', nav_settings: 'Settings',
  nav_keys: 'Keys and integration', nav_members: 'Team', nav_preferences: 'Preferences', app_switch: 'Application',
  no_apps: 'No application is open to you. Ask an administrator to add you to their team.', saved: 'Saved.', save: 'Save',
  settings_name: 'Name', settings_origins: 'Allowed origins (one per line)', settings_origins_hint: 'Sites allowed to embed the widget: https://app.example.com',
  settings_visibility: 'Visibility', settings_visibility_own: 'Everyone sees their own feedback (admins see all)',
  settings_visibility_all: 'Public board: everyone sees and votes', settings_anonymous: 'Accept anonymous visitors',
  settings_types: 'Offered types', settings_delete_window: 'Author deletion window (seconds)',
  settings_item_url: 'Link to a feedback in your app ({id} replaced)', settings_notifications: 'Grouped emails to the team and participants',
  settings_monitor: 'Monitoring addresses receiving everything (one per line)', settings_agent: 'Processing agent',
  settings_trusted: 'Trusted authors (ids, one per line)', settings_approvers: 'Approvers (ids, one per line)',
  settings_stale: 'Resume an interrupted feedback after (hours)', settings_webhooks: 'Webhooks', settings_webhook_url: 'URL (https)',
  settings_webhook_secret: 'Secret (at least 16 characters)', settings_webhook_events: 'Events (empty = all)',
  settings_webhook_add: 'Add a webhook', settings_webhook_remove: 'Remove', keys_publishable: 'Publishable key (widget)',
  keys_identity_secret: 'Identity secret (your app server only)', keys_show: 'Show', keys_hide: 'Hide', keys_copy: 'Copy', keys_copied: 'Copied.',
  keys_rotate: 'Renew the publishable key and identity secret', keys_rotate_title: 'Renew widget keys',
  keys_rotate_message: 'The widget and identity signing must be updated on your site. Continue?',
  keys_secret_title: 'Secret keys (server to server)', keys_secret_label: 'Label', keys_secret_create: 'Create a secret key',
  keys_secret_once: 'Copy this key now: it will never be shown again.', keys_secret_last_used: 'last used {date}',
  keys_secret_never_used: 'never used', keys_secret_revoked: 'revoked', keys_revoke: 'Revoke', keys_revoke_title: 'Revoke key',
  keys_revoke_message: 'Calls signed with this key will be refused immediately.', keys_snippet: 'Integration',
  keys_snippet_widget: 'Widget to embed on your site', keys_snippet_sign: 'Identity signature, server side (Node)',
  members_add: 'Add', members_email: 'Email', members_role: 'Role', role_admin: 'Admin', role_staff: 'Staff', members_remove: 'Remove',
  members_remove_title: 'Remove from team', members_remove_message: 'Remove {name} from this application’s team?',
  nav_admin: 'Administration', outbox_title: 'Outgoing emails',
  outbox_intro: 'No email leaves without approval, except sign-in codes, approval alerts and an application’s monitoring addresses.',
  outbox_disabled: 'Approval is disabled on this server: emails are sent directly.', outbox_tabs: 'Email status',
  outbox_tab_pending: 'To approve', outbox_tab_sent: 'Sent', outbox_tab_rejected: 'Rejected', outbox_tab_failed: 'Failed',
  outbox_empty_pending: 'No email to approve.', outbox_empty_sent: 'No email sent.', outbox_empty_rejected: 'No email rejected.',
  outbox_empty_failed: 'No failed email.', outbox_reload: 'Retry', outbox_source_digest: 'Feedback digest',
  outbox_source_notification: 'Control tower notification', outbox_to: 'To {recipient}', outbox_preview: 'Preview',
  outbox_approve: 'Approve', outbox_retry: 'Resend', outbox_reject: 'Reject', outbox_select: 'Select the email to {recipient}',
  outbox_select_all: 'Select all', outbox_approve_selection: 'Approve selection ({n})', outbox_reject_selection: 'Reject selection ({n})',
  outbox_approve_selection_message: 'Send the selected emails ({n}) right now?', outbox_sent: 'Email sent.',
  outbox_send_failed: 'Sending failed: {error}', outbox_rejected: 'Email rejected.', outbox_conflict: 'This email has already been handled.',
  outbox_bulk_approved: 'Sent: {approved} · failed: {failed}.', outbox_bulk_rejected: 'Rejected: {rejected} · failed: {failed}.',
  outbox_reject_title: 'Reject email', outbox_reject_message: 'A rejected email is never sent.', outbox_reject_reason: 'Reason (optional)',
  outbox_sent_at: 'Sent on {date}', outbox_validated_by: 'Approved by {name}', outbox_rejected_by: 'Rejected by {name}',
  outbox_rejected_auto: 'Automatic rejection', outbox_reason: 'Reason: {reason}', outbox_error: 'Error: {error}', outbox_attempts: 'Attempts: {n}',
  preferences_digest: 'Receive grouped feedback emails', error_generic: 'Something went wrong, please retry.', not_found: 'Page not found.',
}

const de: Record<DashKey, string> = {
  app_title: 'Feedbaacks', login_title: 'Anmeldung zur Feedback-Verwaltung', login_email: 'E-Mail-Adresse', login_send: 'Code erhalten',
  login_sent: 'Falls diese Adresse Zugang hat, wurde soeben ein Code gesendet.', login_code: '6-stelliger Code', login_verify: 'Anmelden',
  login_other_email: 'Andere Adresse verwenden', logout: 'Abmelden', nav_feedback: 'Feedback', nav_settings: 'Einstellungen',
  nav_keys: 'Schlüssel und Integration', nav_members: 'Team', nav_preferences: 'Präferenzen', app_switch: 'Anwendung',
  no_apps: 'Keine Anwendung ist für dich freigegeben. Bitte einen Administrator, dich ins Team aufzunehmen.', saved: 'Gespeichert.', save: 'Speichern',
  settings_name: 'Name', settings_origins: 'Erlaubte Ursprünge (einer pro Zeile)', settings_origins_hint: 'Seiten, die das Widget einbinden dürfen: https://app.beispiel.de',
  settings_visibility: 'Sichtbarkeit', settings_visibility_own: 'Jeder sieht sein eigenes Feedback (Admins sehen alles)',
  settings_visibility_all: 'Öffentliches Board: alle sehen und stimmen ab', settings_anonymous: 'Anonyme Besucher zulassen',
  settings_types: 'Angebotene Typen', settings_delete_window: 'Löschfrist für Autoren (Sekunden)',
  settings_item_url: 'Link zu einem Feedback in deiner App ({id} wird ersetzt)', settings_notifications: 'Gebündelte E-Mails an Team und Beteiligte',
  settings_monitor: 'Überwachungsadressen, die alles erhalten (eine pro Zeile)', settings_agent: 'Bearbeitungsagent',
  settings_trusted: 'Vertrauenswürdige Autoren (IDs, eine pro Zeile)', settings_approvers: 'Freigebende (IDs, eine pro Zeile)',
  settings_stale: 'Unterbrochenes Feedback wieder aufnehmen nach (Stunden)', settings_webhooks: 'Webhooks', settings_webhook_url: 'URL (https)',
  settings_webhook_secret: 'Geheimnis (mindestens 16 Zeichen)', settings_webhook_events: 'Ereignisse (leer = alle)',
  settings_webhook_add: 'Webhook hinzufügen', settings_webhook_remove: 'Entfernen', keys_publishable: 'Öffentlicher Schlüssel (Widget)',
  keys_identity_secret: 'Identitätsgeheimnis (nur dein App-Server)', keys_show: 'Anzeigen', keys_hide: 'Verbergen', keys_copy: 'Kopieren', keys_copied: 'Kopiert.',
  keys_rotate: 'Öffentlichen Schlüssel und Identitätsgeheimnis erneuern', keys_rotate_title: 'Widget-Schlüssel erneuern',
  keys_rotate_message: 'Widget und Identitätssignatur müssen auf deiner Seite aktualisiert werden. Fortfahren?',
  keys_secret_title: 'Geheime Schlüssel (Server zu Server)', keys_secret_label: 'Bezeichnung', keys_secret_create: 'Geheimen Schlüssel erstellen',
  keys_secret_once: 'Kopiere diesen Schlüssel jetzt: Er wird nie wieder angezeigt.', keys_secret_last_used: 'zuletzt verwendet {date}',
  keys_secret_never_used: 'nie verwendet', keys_secret_revoked: 'widerrufen', keys_revoke: 'Widerrufen', keys_revoke_title: 'Schlüssel widerrufen',
  keys_revoke_message: 'Mit diesem Schlüssel signierte Aufrufe werden sofort abgelehnt.', keys_snippet: 'Integration',
  keys_snippet_widget: 'Widget für deine Seite', keys_snippet_sign: 'Identitätssignatur, serverseitig (Node)',
  members_add: 'Hinzufügen', members_email: 'E-Mail', members_role: 'Rolle', role_admin: 'Admin', role_staff: 'Team', members_remove: 'Entfernen',
  members_remove_title: 'Aus dem Team entfernen', members_remove_message: '{name} aus dem Team dieser Anwendung entfernen?',
  nav_admin: 'Verwaltung', outbox_title: 'Ausgehende E-Mails',
  outbox_intro: 'Keine E-Mail geht ohne Freigabe raus, außer Anmeldecodes, Freigabehinweisen und den Überwachungsadressen einer Anwendung.',
  outbox_disabled: 'Die Freigabe ist auf diesem Server deaktiviert: E-Mails werden direkt versendet.', outbox_tabs: 'E-Mail-Status',
  outbox_tab_pending: 'Freizugeben', outbox_tab_sent: 'Gesendet', outbox_tab_rejected: 'Abgelehnt', outbox_tab_failed: 'Fehlgeschlagen',
  outbox_empty_pending: 'Keine E-Mail freizugeben.', outbox_empty_sent: 'Keine gesendete E-Mail.', outbox_empty_rejected: 'Keine abgelehnte E-Mail.',
  outbox_empty_failed: 'Keine fehlgeschlagene E-Mail.', outbox_reload: 'Erneut versuchen', outbox_source_digest: 'Feedback-Zusammenfassung',
  outbox_source_notification: 'Benachrichtigung des Kontrollturms', outbox_to: 'An {recipient}', outbox_preview: 'Vorschau',
  outbox_approve: 'Freigeben', outbox_retry: 'Erneut senden', outbox_reject: 'Ablehnen', outbox_select: 'E-Mail an {recipient} auswählen',
  outbox_select_all: 'Alle auswählen', outbox_approve_selection: 'Auswahl freigeben ({n})', outbox_reject_selection: 'Auswahl ablehnen ({n})',
  outbox_approve_selection_message: 'Die ausgewählten E-Mails ({n}) jetzt senden?', outbox_sent: 'E-Mail gesendet.',
  outbox_send_failed: 'Versand fehlgeschlagen: {error}', outbox_rejected: 'E-Mail abgelehnt.', outbox_conflict: 'Diese E-Mail wurde bereits bearbeitet.',
  outbox_bulk_approved: 'Gesendet: {approved} · fehlgeschlagen: {failed}.', outbox_bulk_rejected: 'Abgelehnt: {rejected} · fehlgeschlagen: {failed}.',
  outbox_reject_title: 'E-Mail ablehnen', outbox_reject_message: 'Eine abgelehnte E-Mail wird nie gesendet.', outbox_reject_reason: 'Grund (optional)',
  outbox_sent_at: 'Gesendet am {date}', outbox_validated_by: 'Freigegeben von {name}', outbox_rejected_by: 'Abgelehnt von {name}',
  outbox_rejected_auto: 'Automatische Ablehnung', outbox_reason: 'Grund: {reason}', outbox_error: 'Fehler: {error}', outbox_attempts: 'Versuche: {n}',
  preferences_digest: 'Gebündelte Feedback-E-Mails erhalten', error_generic: 'Ein Fehler ist aufgetreten, bitte erneut versuchen.', not_found: 'Seite nicht gefunden.',
}

export const dashDictionaries: Record<Locale, Record<DashKey, string>> = { fr, en, de }

export function detectLocale(): Locale {
  const l = (typeof navigator !== 'undefined' ? navigator.language : 'fr').slice(0, 2)
  return l === 'en' || l === 'de' ? l : 'fr'
}

export const locale = detectLocale()
export const d = translator<DashKey>(dashDictionaries[locale])
